import { type Actor } from '@shared/board'
import { clsx } from 'clsx'
import { avatarUri } from '@/lib/avatar'

/** A person's or an AI conversation's avatar, stable for its id. Decorative: say the name next to it. */
export function Avatar({
  actor,
  size = 16,
  className,
}: {
  actor: Actor
  size?: number
  className?: string
}) {
  return (
    <img
      src={avatarUri(`${actor.kind}:${actor.id}`)}
      width={size}
      height={size}
      alt=""
      draggable={false}
      className={clsx('flex-none rounded-full select-none', className)}
    />
  )
}
